import { mapState } from 'vuex'
import { find } from 'lodash'
export default {
  data () {
    return {
      canDoReturnBundles: [],
      cancelReason: [],
      WithdrawBundles: [],
      enableWithdrawBundles: []
    }
  },

  props: {
    device: {
      type: Object,
      default: null
    },
    replenshipment: {
      type: Object,
      default: null
    },
    deviceReturnInfos: {
      type: Object,
      default: null
    },

    replenshipmentReturnInfos: {
      type: Object,
      default: null
    },

    rightToReturnDays: {
      type: Number,
      default: null
    },

    displayModifyButton: {
      type: Boolean,
      default: false
    },

    disabledAllAccordion: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('subscription', ['subscriptionDetails']),

    allowNextStep () {
      if (this.canDoReturnBundles.length > 0) {
        return this.canDoReturnBundles.filter(item => item.checked)
      }
    },

    allowToWithdraw () {
      return this.enableWithdrawBundles.filter(item => item.checked)
    },

    returnOptionType () {
      let scope = {}
      this.allowNextStep.map(item => {
        if (item.checked) {
          if (item.text === this.device.name) {
            scope.deviceReturn = true
            scope.returnOptionType = 'TryBuy'
          }
          if (item.text === this.replenshipment.name) {
            scope.replenshipmentReturn = true
            scope.returnOptionType = 'Replenishment'
          }
        }
      })
      if (scope.deviceReturn && scope.replenshipmentReturn) {
        scope.returnOptionType = 'TryBuyAndReplenishment'
      }
      return scope.returnOptionType
    },

    tryBuyRatePlan () {
      return find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuy' }) ||
        find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyPurchase' }) ||
        find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyDepreciation' }) ||
        find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyDepreciationPurchase' })
    },

    replenishmentRatePlan () {
      return find(this.subscriptionDetails.ratePlans, { modelType: 'Replenishment' }) ||
      find(this.subscriptionDetails.ratePlans, { modelType: 'ReplenishmentStandard' })
    },

    initialCancelReason () {
      return this.subscriptionDetails.cancelReasonOptions.map(item => ({
        text: item,
        checked: false
      }))
    },

    cancelReasonSelected () {
      let cancelReasonSelected = ''
      this.cancelReason.find(item => {
        if (item.checked) {
          cancelReasonSelected = cancelReasonSelected + item.text + ';'
        }
      })
      return cancelReasonSelected.substring(0, cancelReasonSelected.length - 1)
    },

    consumerEmail () {
      return JSON.parse(window.sessionStorage.getItem('personalDetail')).email
    },

    tryBuyCanDoReturn () {
      return this.deviceReturnInfos && this.deviceReturnInfos.returnable
    },

    tryBuyCanDoWithdraw () {
      return this.deviceReturnInfos && this.deviceReturnInfos.returningWithdrawable
    },

    replenshipmentCanDoWithdraw () {
      return this.replenshipmentReturnInfos && this.replenshipmentReturnInfos.returningWithdrawable
    },

    replenshipmentCanDoReturn () {
      return this.replenshipmentReturnInfos && (this.replenshipmentReturnInfos.returnable || this.subscriptionDetails.ableToCancelReplenishment)
    },

    withdrawSelected () {
      let canDoWithdraw = {}
      if (this.subscriptionDetails.ratePlans.length > 1) {
        this.allowToWithdraw.find(item => item.checked)
        this.allowToWithdraw.map(item => {
          if (item.checked && item.id === 'brush heads') {
            canDoWithdraw.replenshipmentReturn = true
            canDoWithdraw.scope = 'Replenishment'
          } else if (item.checked && item.id === 'toothbrush handle') {
            canDoWithdraw.deviceReturn = true
            canDoWithdraw.scope = 'TryBuy'
          }
        })
        if (canDoWithdraw.deviceReturn && canDoWithdraw.replenshipmentReturn) {
          canDoWithdraw.scope = 'TryBuyAndReplenishment'
        }
      } else if (this.subscriptionDetails.ratePlans.length === 1) {
        if (this.device && this.tryBuyCanDoWithdraw) {
          canDoWithdraw.scope = 'TryBuy'
        } else if (this.replenshipment && this.replenshipmentCanDoWithdraw) {
          canDoWithdraw.scope = 'Replenishment'
        }
      }
      return canDoWithdraw.scope
    },

    isOnlyDeviceRatePlan () {
      return this.subscriptionDetails.ratePlans.length === 1 &&
        this.subscriptionDetails.ratePlans[0].modelType !== 'Replenishment' && this.subscriptionDetails.ratePlans[0].modelType !== 'ReplenishmentStandard' &&
        this.deviceReturnInfos
    },

    needNewCancellationFlow () {
      return !this.isOnlyDeviceRatePlan
    },

    enableModifyButton () {
      return this.displayModifyButton || (this.subscriptionDetails.tryBuyHasShipped &&
        !this.disabledAllAccordion && !this.subscriptionDetails.ableToResumeReplenishment)
    }
  },

  methods: {
    returnBundleOptions () {
      if (this.tryBuyCanDoReturn && this.replenshipmentCanDoReturn) {
        return [{
                  text: this.device.name,
                  checked: false
                },
                {
                  text: this.replenshipment.name,
                  checked: false
        }]
      } else if (this.tryBuyCanDoReturn && !this.replenshipmentCanDoReturn) {
        return [{
          text: this.device.name,
          checked: false
        }]
      } else if (!this.tryBuyCanDoReturn && this.replenshipmentCanDoReturn) {
        return [{
          text: this.replenshipment.name,
          checked: false
        }]
      } else if (this.subscriptionDetails.ratePlans.length > 1 && !this.tryBuyCanDoReturn && !this.replenshipmentCanDoReturn && this.subscriptionDetails.ableToCancelReplenishment) {
        return [
          {
            text: this.replenshipment.name,
            checked: false
          }
        ]
      } else {
        return []
      }
    },

    doWithdrawBundles () {
      if (this.subscriptionDetails.ratePlans.length > 1) {
        if (this.tryBuyCanDoWithdraw && this.replenshipmentCanDoWithdraw) {
          return [
            {
              text: this.$t('subscription_return.bundles.cancelOptions.text', { replenishmentName: this.replenshipment.name }),
              checked: false,
              id: 'brush heads'
            },
            {
              text: this.$t('subscription_return.bundles.cancelOptions.subText', { deviceName: this.device.name }),
              checked: false,
              id: 'toothbrush handle'
            }
          ]
        } else if (this.tryBuyCanDoWithdraw && !this.replenshipmentCanDoWithdraw) {
          return [
            {
              text: this.$t('subscription_return.bundles.cancelOptions.subText', { deviceName: this.device.name }),
              checked: false,
              id: 'toothbrush handle'
            }
          ]
        } else if (!this.tryBuyCanDoWithdraw && this.replenshipmentCanDoWithdraw) {
          return [
            {
              text: this.$t('subscription_return.bundles.cancelOptions.text', { replenishmentName: this.replenshipment.name }),
              checked: false,
              id: 'brush heads'
            }
          ]
        }
      }
    },

    modifySubscription () {
      if (this.enableModifyButton) {
        this.$scrollTo('[data-scroll="modifyAccordion"]', {
          offset: -400
        })
        this.$bus.$emit('close-modal', 'newFlowForCancelReplenishment')
        this.emptyCancelData()
        this.$bus.$emit('expend-modify-accordion')
      }
    },

    pauseReplenishment () {
      this.$bus.$emit('open-modal', 'replenishmentPause')
      this.$bus.$emit('close-modal', 'newFlowForCancelReplenishment')
      this.emptyCancelData()
    }
  }
}
